export default __webpack_public_path__ + "static/media/joolez-icon.72d32b7b.png";